import { Controller } from "@hotwired/stimulus";

var CharCountController = class extends Controller {
  connect() {
    this.update();
  }

  update() {
    var value = this.inputTarget.value
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n");
    var count = value.length;
    var over = count > this.maxValue;
    this.noticeTarget.hidden = !over;
    if (over) {
      this.noticeTarget.textContent = this.noticeTarget.dataset.message.replace(
        "%{count}",
        count,
      );
    }
  }
};

CharCountController.targets = ["input", "notice"];
CharCountController.values = { max: Number };

export default CharCountController;
